import { Component, ChangeDetectionStrategy, ChangeDetectorRef, OnInit, OnDestroy, ViewChild } from "@angular/core";
import { Subscription, Observable } from "rxjs";

// UAPP Core Imports
import { CoreCOMService } from "../../services/com.service";
import { HomeService } from "./home.service";

// eigene Datenspeicher
import { SwiperConfigInterface, SwiperAutoplayInterface, SwiperComponent } from "ngx-swiper-wrapper";
import { CoreLogService } from "../../services/log.service";
import { InternationalisationService } from "../../forked/angular-internationalisation";
import { HomeSliderViewModel, HomeTileViewModel, HomePrioTileViewModel, ItemGroupViewModel, LocationViewModel, NavigationTitleViewModel, OrdertypeViewModel, LocationWebshopViewModel } from "../../shared/models";

import { SnackBarService } from "../../services/snackBar.service";
import { SortDirection, ContentType, VoucherServiceType } from "../../shared/contentTypes";
import { OverlaySpinnerService } from "../overlayspinner/overlaySpiner.service";
import { PagingHelper } from "../../shared/pagingHelper";
import { SortOption } from "../../shared/models/sort.model";
import { NavigationHelperService } from "../../services/navigationHelper.service";
import { HomeReadyService } from "../../services/homeReady.service";
import { ExternalLinksSettingsService } from "../../services/ExternalLinksSettings.service";
import { EMenuService } from "../../services/emenu.service";
import { NavigationService } from "../../services/navigation.service";

// Auswahl
import { WebShopService } from "../../services/webShop.service";
import { WebShopMode } from "../../services/IWebShopService";
import { BottomSheetHelperService } from "../../services/bottomSheetHelper.service";
import { trigger, transition, query, style, stagger, animate } from "@angular/animations";

import { MainnavService, ViewType, Community, Paymentoption } from "../mainNav/mainnav.service";

import { Router } from "@angular/router";
import { LocationService } from "../location/location.service";
import { MenugroupService } from "../menugroup/menugroup.service";
import { WebshopOrdertypesService } from "../../services/webShopOrdertypes.service";
import { delay } from "rxjs/operators";
import { InHouseOrderService } from "../../services/inHouseOrder.service";
import { RemoteGroupOrderService } from "../../services/RemoteGroupOrder.service";
import { CookiePolicyComponent } from "../../modalDialogs/cookiePolicy/cookiePolicy.component";
import { LanguageDialogComponent } from "../../modalDialogs/languageDialog/languageDialog.component";
import { LicenseDialogComponent } from "../../modalDialogs/licenseDialog/licenseDialog.component";
import { AccessibiltyDialogComponent } from "../../modalDialogs/accessibiltyDialog/accessibiltyDialog.component";

@Component({
  selector: "home",
  templateUrl: "./home.component.html",
  styleUrls: ["./home.component.scss"],
  providers: [HomeService, OverlaySpinnerService],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    trigger("serviceButtonEntering", [
      transition("* => *", [
        query(".choice", [
          style({ transform: "scale(0)" }),
          stagger(100, [
            animate("400ms ease-out", style({ transform: "scale(1.1)" })),
            animate("100ms ease-in-out", style({ transform: "scale(1)" }))
          ])
        ], { optional: true })
      ])
    ]),
  ]
})

/**
* Startseite
*/
export class HomeComponent implements OnInit, OnDestroy {
  public homeSliders: HomeSliderViewModel[] = []; // user for Top slider
  public firstRowHomeTileList: HomeTileViewModel[]; // used for tiles under the top slider
  public homePriorityList: HomePrioTileViewModel[] = []; // used for Priority Tile
  public homeTileList: HomeTileViewModel[] = []; // used for tiles under priority Tile
  public gridTileList: any[];

  private _pagingHelper: PagingHelper = new PagingHelper();
  private sortOption: SortOption[] = [];
  public hasHomeslider: boolean = true;
  public hasFirstRowHomeTile: boolean = true;
  public hasHomePriority: boolean = true;
  public hasHomeTile: boolean = true;
  public isEMenu: boolean;

  private _langSubscriber: Subscription;
  private _initialLoadSubscription: Subscription;
  private _homeSliderSubscription: Subscription;
  private _homeTileSubscription: Subscription;
  private _homePriorityTileSubscription: Subscription;
  private _inHouseUiDataSubscription: Subscription;
  private _viewTypeSubscription: Subscription;

  public WebShopMode = WebShopMode;
  public isSmallView: boolean = false;
  public locations: LocationViewModel[];
  public itemGroups: ItemGroupViewModel[];

  public navigationTitleMenu: NavigationTitleViewModel = new NavigationTitleViewModel();
  public navigationTitleLocation: NavigationTitleViewModel = new NavigationTitleViewModel();;
  public areDesktopTilesExpanded: boolean = false;
  private enabledVoucherCharge: boolean = false;

  public hasData: boolean = true;

  public ordertypes$: Observable<OrdertypeViewModel[]>;
  private _ordertypesSubscription: Subscription;

  public showInHouseTableButton: boolean = false;
  public showRemoteGroupOrderHomeButton$: Observable<boolean>;
  public displaySummaryButton$: Observable<boolean>;
  public groupStatusFinished$: Observable<boolean>;

  public isMobile: boolean;

  // Footer data - shared via MainnavService
  public get communities(): Community[] {
    return this._mainnavService.communities;
  }
  public get paymentoptions(): Paymentoption[] {
    return this._mainnavService.paymentoptions;
  }
  public get terms(): any[] {
    return this._mainnavService.terms;
  }
  public get canSelectLanguage(): boolean {
    return this._mainnavService.canSelectLanguage;
  }
  public get currentLocale(): string {
    return this._mainnavService.currentLocale;
  }
  public get company_name(): string {
    return this._mainnavService.company_name;
  }
  public get version(): string {
    return this._mainnavService.version;
  }
  public get isAccessibilityModeActive(): boolean {
    return this._mainnavService.isAccessibilityModeActive;
  }

  // ViewChildren
  @ViewChild('swiperSpeisekarte') swiperSpeisekarte: any; //SwiperComponent
  @ViewChild('swiperStandorte') swiperStandorte: any; //SwiperComponent

  public checkService(mode: WebShopMode) {
    const me = this;
    const serviceID = me._webShopService.getServiceMode();
    const isRemoteOrder = serviceID === WebShopMode.DeliveryGroup || serviceID === WebShopMode.PickupGroup
    if (isRemoteOrder && me._remoteGroupOrderService.groupId !== 0) {
      me._webShopService.openWarningLeaveGroup(me._webShopService.locationID, mode);
    } else {
      me._webShopService.openWarningResetBasketDialogIfNeed(me._webShopService.locationID, mode, (agree) => {
        if (agree) {
          me.setService(mode);
        } /* else do nothing */
      });
    }

  }

  /**initilize service; use seperate initialization for voucher service */
  private setService(servicemode: WebShopMode) {
    const me = this;
    if (servicemode === WebShopMode.Webvoucher) {
      me.intializeVoucherService();
    } else {
      me.navigateToMenuLocation(servicemode);
    }
  }

  /**initialize service for voucher */
  private async intializeVoucherService(): Promise<void> {
    const me = this;
    let serviceMode: WebShopMode;
    const mode = WebShopMode.Webvoucher;
    if (me.enabledVoucherCharge) {
      serviceMode = await me._webShopService.setServiceMode(mode, true, me._webShopService.voucherServiceType);
      me._router.navigate(["/vouchercredit"]);
    } else {
      serviceMode = await me._webShopService.setServiceMode(mode, true, VoucherServiceType.Order);
      me._webShopService.HasSingleLocation(mode)
        .then(response => {
          if (response) {
            me._webShopService.tryAndRouteToSingleVariableWebvoucher();
          } else {
            me._router.navigate(["/menulocation"]);
          }
        })
        .catch(e => {
          me._coreLogService.error("MenuServiceSelectorComponent.intializeVoucherService", "_webShopService.HasSingleLocation", e);
          me._snackBarService.ShowErrorMessageFailed(37);
        });
    }
  }

  private displayGroupSummary() {
    const me = this;
    me._remoteGroupOrderService.handleCacheGroupSummary().then(() => {
      me.displaySummaryButton$ = me._remoteGroupOrderService.displaySummary$;
      me.PushChanges();
    })
  }

  private handleNavigateSingleLocation(hasSingleLocation: boolean, mode: WebShopMode) {
    const me = this;
    if (hasSingleLocation) {
      if (mode === me.WebShopMode.TakeAway) {
        me.initializeServiceTimeSelectionOptions(mode);
        // viewing, ticket, retail
      } else {
        me._router.navigate(["/menugroup"]);
      }
    } else {
      //select location
      me._router.navigate(["/menulocation"]);
    }
  }

  private async initializeServiceTimeSelectionOptions(serviceMode: WebShopMode) {
    const me = this;
    const location = await me._locationService.GetWebshopLocationInfoViewModel(serviceMode, me._webShopService.locationID);
    await me._webShopService.initializeAndProcessServiceTime({
      serviceMode: serviceMode,
      location: location,
    });
  }

  private async navigateToMenuLocation(mode: WebShopMode) {
    const me = this;
    let serviceMode: WebShopMode;
    serviceMode = await me._webShopService.setServiceMode(mode);
    if (serviceMode != null) {
      if (mode === me.WebShopMode.OrderToTable) {
        me._router.navigate(["/qrcodescanner"]);
      } else if (mode === me.WebShopMode.TakeAway || mode === me.WebShopMode.Ticket || mode === me.WebShopMode.Retail || mode === me.WebShopMode.Viewing) {
        me._webShopService.HasSingleLocation(mode)
          .then(response => {
            //single location
            me.handleNavigateSingleLocation(response, mode);
          })
          .catch(e => {
            me._coreLogService.error("HomeComponent.navigateToMenuLocation", "_webShopService.HasSingleLocation", e);
            me._snackBarService.ShowErrorMessageFailed(38);
          });
      } else {
        //delivery
        me._router.navigate(["/orderAddressQuery"]);
      }
    } else {
      me._coreLogService.error("HomeComponent.navigateToMenuLocation", "serviceMode invalid/null", serviceMode);
      me._snackBarService.ShowErrorMessageFailed(39);
    }
  }

  // swiper
  private homeSliderAutoPlay: SwiperAutoplayInterface = {
    delay: 3000
    // , stopOnLastSlide: false
    , disableOnInteraction: false
    // , reverseDirection: false
    // ,waitForTransition : boolean
  };

  private homePriorityAutoPlay: SwiperAutoplayInterface = {
    delay: 4000
    // , stopOnLastSlide: false
    , disableOnInteraction: false
    // , reverseDirection: false
    // ,waitForTransition : boolean
  };

  public homeSliderconfig: SwiperConfigInterface = {
    init: true,
    direction: "horizontal",
    slidesPerView: 1,
    keyboard: false,
    mousewheel: false,
    scrollbar: false,
    navigation: false,
    pagination: false,
    // loop: true,
    spaceBetween: 0,
    autoplay: this.homeSliderAutoPlay
  };

  public homePriorityTileconfig: SwiperConfigInterface = {
    init: true,
    direction: "horizontal",
    slidesPerView: 1,
    keyboard: false,
    mousewheel: false,
    scrollbar: false,
    navigation: false,
    pagination: false,
    // loop: true,
    spaceBetween: 0,
    autoplay: this.homePriorityAutoPlay
  };

  private locationAutoPlay: SwiperAutoplayInterface = {
    delay: 5000
    // , stopOnLastSlide: false
    , disableOnInteraction: true
    // , reverseDirection: false
    // ,waitForTransition : boolean
  };

  public locationSliderconfig: SwiperConfigInterface = {
    init: true,
    direction: "horizontal",
    slidesPerView: 3,
    keyboard: false,
    mousewheel: false,
    scrollbar: false,
    navigation: false,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
      type: 'custom',
      renderCustom: (swiper, current, total) => {
        return this.renderSegmentedPaginationCustom(swiper, current, total);
      }
    },
    // loop: true,
    spaceBetween: 0,
    autoplay: this.locationAutoPlay,
    breakpoints: {
      480: {
        slidesPerView: 1
      },
      785: {
        slidesPerView: 2
      }
    }
  };

  private itemGroupAutoPlay: SwiperAutoplayInterface = {
    delay: 5000
    // , stopOnLastSlide: false
    , disableOnInteraction: true
    // , reverseDirection: false
    // ,waitForTransition : boolean
  };

  public itemGroupSliderconfig: SwiperConfigInterface = {
    init: true,
    direction: "horizontal",
    slidesPerView: 4,
    keyboard: false,
    mousewheel: false,
    scrollbar: false,
    navigation: false,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
      type: 'custom',
      renderCustom: (swiper, current, total) => {
        return this.renderSegmentedPaginationCustom(swiper, current, total);
      }
    },
    // loop: true,
    spaceBetween: 0,
    autoplay: this.itemGroupAutoPlay,
    breakpoints: {
      480: {
        slidesPerView: 1
      },
      785: {
        slidesPerView: 2
      }
    }
  };
  // end of Swiper

  constructor(private _changeDetectorRef: ChangeDetectorRef
    , private _coreCOMService: CoreCOMService
    , private _homeService: HomeService
    , private _menugroupService: MenugroupService
    , private _webShopService: WebShopService
    , private _bottomSheetHelperService: BottomSheetHelperService
    , private _mainnavService: MainnavService
    , private _snackBarService: SnackBarService
    , private _coreLogService: CoreLogService
    , private internationalisationService: InternationalisationService
    , private _overlaySpinnerService: OverlaySpinnerService
    , private _navigationService: NavigationService
    , private _navigationHelperService: NavigationHelperService
    , private _homeReadyService: HomeReadyService
    , private _externalLinksSettingsService: ExternalLinksSettingsService
    , private _router: Router
    , _webshopOrdertypesService: WebshopOrdertypesService
    , private _locationService: LocationService
    , private _eMenuService: EMenuService
    , private _inHouseOrderService: InHouseOrderService
    , private _remoteGroupOrderService: RemoteGroupOrderService) {
    this._coreCOMService.environment.loader.removeTask("home_component");
    this.ordertypes$ = _webshopOrdertypesService.supportedOrdertypes$.pipe(delay(0)); // delay is used to always trigger a change for the animations; Current Angular Version(6) seems to have problems with async piped enter animations.
    this.isMobile = this._coreCOMService.environment.client.isMobile;
  }

  ngOnDestroy(): void {
    const me = this;
    if (me._langSubscriber) {
      me._langSubscriber.unsubscribe();
    }
    if (me._homeSliderSubscription) {
      me._homeSliderSubscription.unsubscribe();
    }
    if (me._homePriorityTileSubscription) {
      me._homePriorityTileSubscription.unsubscribe();
    }
    if (me._inHouseUiDataSubscription) {
      me._inHouseUiDataSubscription.unsubscribe();
    }
    if (me._homeTileSubscription) {
      me._homeTileSubscription.unsubscribe();
    }
    if (me._viewTypeSubscription) {
      me._viewTypeSubscription.unsubscribe();
    }
  }

  private PushChanges(): void {
    try {
      if (!this._changeDetectorRef['destroyed']) {
        this._changeDetectorRef.detectChanges();
      }
    } catch (e) {
      this._coreLogService.error("HomeComponent.PushChanges", "_changeDetectorRef.detectChanges (catch)", e);
    }
  }

  ngOnInit() {
    const me = this;
    me.isEMenu = me._eMenuService.isActive;
    me.sortOption.push(me._pagingHelper.createSortOption("sort_nr", SortDirection.ASC));

    me.showInHouseTableButton = me._inHouseOrderService.UiData.place_no > 0;
    // bei änderung des Tisches im InHouseOrder entsprechend die UI aktualisieren
    me._inHouseUiDataSubscription = me._inHouseOrderService.ObserveUiDataChanged.subscribe((newUiData) => {
      const hasPlaceOnTable = newUiData.place_no > 0
      if (me.showInHouseTableButton != hasPlaceOnTable) {
        me.showInHouseTableButton = hasPlaceOnTable;
        me.PushChanges();
      }
    });
    me.showRemoteGroupOrderHomeButton$ = me._remoteGroupOrderService.displayGroupNav$;
    me.groupStatusFinished$ = me._remoteGroupOrderService.groupStatusFinished$;
    me.displayGroupSummary();

    me._webShopService.getWebshopSettingsDataModel()
      .then((webshopSettingsDataModel) => {
        me.enabledVoucherCharge = webshopSettingsDataModel.is_vouchercharge_enabled;
      })
      .catch(e => {
        me._coreLogService.error("HomeComponent.Init", "_webShopService.getWebshopSettingsDataModel", e);
        me._snackBarService.ShowErrorMessageFailed(41);
      });

    me.onViewTypeChanges(me._mainnavService.viewType);
    me._viewTypeSubscription = me._mainnavService.observeViewTypeChanges.subscribe((viewType) => {
      me.onViewTypeChanges(viewType);
      me.PushChanges();
    });

    me._initialLoadSubscription = me._overlaySpinnerService.InitialLoadObserver.subscribe(() => {
      setTimeout(() => {
        me._homeReadyService.triggerHomeReady();
        me._coreCOMService.environment.splashscreen.hide();
        me._initialLoadSubscription.unsubscribe();
      }, 500);
    });
    me._langSubscriber = me.internationalisationService.localeChanged.subscribe(() => {
      me.PushChanges();
    });

    me._homeSliderSubscription = me._homeService.HomeSliderObserveChanges.subscribe(() => {
      me.reloadAndRenderData();
    });
    me._homePriorityTileSubscription = me._homeService.HomePriorityObserveChanges.subscribe(() => {
      me.reloadAndRenderData();
    });
    me._homeTileSubscription = me._homeService.HomeTileObserveChanges.subscribe(() => {
      me.reloadAndRenderData();
    });

    me._locationService.GetLocationViewModel(false).then(locations => {
      me.locations = locations;
      me.PushChanges();
    });

    me._menugroupService.GetAllItemGroups().then(itemGroups => {
      me.itemGroups = itemGroups.sort((a, b) => a.sort_nr - b.sort_nr);
      me.PushChanges();
    });

    Promise.all([
      me.getNavigationName(ContentType.Menu),
      me.getNavigationName(ContentType.Location)
    ]).then((result) => {
      me.navigationTitleMenu = result[0];
      me.navigationTitleLocation = result[1];
      me.PushChanges();
    })

    me.reloadAndRenderData();
  }

  private onViewTypeChanges(viewType: ViewType) {
    const me = this;
    me.isSmallView = (viewType === ViewType.Small);
  }

  /* sorts the location slider by asc */
  public get sortlocation(): LocationViewModel[] {
    const me = this;
    const sortedLocations = me.sortlocationasc();
    if (sortedLocations.length === 0) {
      console.error('Sorting has failed');
      return me.locations || [];
    }
    return sortedLocations;
  }

  private sortlocationasc(): LocationViewModel[] {
    const me = this;
    if (!me.locations || me.locations.length === 0) {
      return [];
    }

    return me.locations.slice().sort((a, b) => {
      if (a.label < b.label) return -1;
      if (a.label > b.label) return 1;
      return 0;
    });
  }

  private reloadAndRenderData() {
    const me = this;
    me._overlaySpinnerService.ShowLayoutSpinner();
    Promise.all([
      me._homeService.GetHomeSliderViewModel().catch(e => {
        me._snackBarService.ShowErrorMessageFailed(42);
        me._coreLogService.error("HomeComponent.reloadAndRenderData", "GetHomeSliderViewModel (catch)", e);
      })
      , me._homeService.GetHomeTileViewModel().catch(e => {
        me._snackBarService.ShowErrorMessageFailed(43);
        me._coreLogService.error("HomeComponent.reloadAndRenderData", "GetHomeTileViewModel (catch)", e);
      })
      , me._homeService.GetHomePriorityTileViewModel().catch(e => {
        me._snackBarService.ShowErrorMessageFailed(44);
        me._coreLogService.error("HomeComponent.reloadAndRenderData", "GetHomePriorityTileViewModel (catch)", e);
      })
    ])
      .then(responses => {
        if (responses[0]) {
          me.getHomePageSlider(responses[0]);
        }
        if (responses[1]) {
          me.getHomePageTile(responses[1]);
        }
        if (responses[2]) {
          me.getHomePagePriorityTile(responses[2]);
        }

        const resetSlider = (swipercomponent, duration, step) => {
          if (duration > 0) {
            if (swipercomponent) {
              if (swipercomponent.directiveRef) {
                if (swipercomponent.directiveRef.instance) {
                  swipercomponent.directiveRef.instance.update();
                }
              }
            }
            setTimeout(() => {
              resetSlider(swipercomponent, duration - step, step);
            }, step)
          }
        }
        // ! Temporary Solution for wrong size of SpeisekartenSlider
        resetSlider(me.swiperSpeisekarte, 1500, 300);
        resetSlider(me.swiperStandorte, 1500, 300);

        me.PushChanges();
        me._overlaySpinnerService.HideLayoutSpinner();
      })
      .catch(e => {
        // TODO: Does this part run?
        me._overlaySpinnerService.HideLayoutSpinner();
        me._snackBarService.ShowErrorMessageFailed(45);
        me._coreLogService.error("HomeComponent.reloadAndRenderData", "PromiseAll (catch)", e);
      });
  }

  /** Navigates to a specific ContentType and ID */
  public setTargetNavigation(viewModel: any) {
    const me = this;
    if (viewModel.contentType !== ContentType.ExternalLink) {
      me._navigationHelperService.navigateToContent(viewModel.contentType, viewModel.contentId);
    } else if (viewModel.contentId) {
      const contentExtra = viewModel.content_extra.split("|");
      me._externalLinksSettingsService.RouteToExternalLinks(contentExtra[1], !!(+(contentExtra[0])));
    } else {
      me._externalLinksSettingsService.RouteToExternalLinks();
    }
  }

  private getHomePageSlider(sliders): void {
    const me = this;
    // Filter unsupported tiles
    sliders = sliders.filter(slider => me.isContenttypeSupported(slider.contentType));
    sliders.sort(me._pagingHelper.fieldSorter(me.sortOption));
    me.homeSliders = sliders;
    me.hasHomeslider = sliders.length > 0;
  }

  private getHomePageTile(homeTiles): void {
    const me = this;
    // Filter unsupported tiles
    homeTiles = homeTiles.filter(homeTile => me.isContenttypeSupported(homeTile.contentType));
    const allHomeTile: HomeTileViewModel[] = [];
    if (homeTiles && homeTiles.length > 0) {
      allHomeTile.push(...homeTiles);
      // First two Tile located after slider and before priority Tile
      allHomeTile.sort(me._pagingHelper.fieldSorter(me.sortOption));
      me.firstRowHomeTileList = allHomeTile.slice(0, 2);
      me.hasFirstRowHomeTile = true;
      if (allHomeTile.length > 2) {
        me.homeTileList = allHomeTile.slice(2);
        me.hasHomeTile = true;
      } else {
        // no more than two tiles
      }
    } else {
      // No Data for tiles in home page
    }
  }

  private getHomePagePriorityTile(priorityTiles): void {
    const me = this;
    // Filter unsupported tiles
    priorityTiles = priorityTiles.filter(priorityTile => me.isContenttypeSupported(priorityTile.contentType));
    priorityTiles.sort(me._pagingHelper.fieldSorter(me.sortOption));
    me.homePriorityList = priorityTiles;
    me.hasHomePriority = priorityTiles.length > 0;
  }

  private isContenttypeSupported(ct: ContentType): boolean {
    const me = this;
    return me._navigationService.isContenttypeSupported(ct);
  }

  private async getNavigationName(ct: ContentType): Promise<NavigationTitleViewModel> {
    const me = this;
    return me._navigationService.GetRouteNavigationTitleViewModelForContentType(ct);
  }

  public navigateToMenuList(itemGroup: ItemGroupViewModel) {
    const me = this;
    const activeItemGroupId = itemGroup.id;
    me._router.navigate(["/menu", activeItemGroupId]);
  }

  public navigateToLocationDetail(locationID: number) {
    const me = this;
    me._router.navigate(["/locationdetail", locationID]);
  }

  public expandDesktopTiles() {
    const me = this;
    me.areDesktopTilesExpanded = !me.areDesktopTilesExpanded;
    me.PushChanges();
  }

  public canExpand(): boolean {
    const me = this;
    let count = 0;
    if (me.firstRowHomeTileList) {
      count += this.firstRowHomeTileList.length;
    }
    if (me.homeTileList) {
      count += this.homeTileList.length;
    }
    if (me.homePriorityList && me.homePriorityList.length > 0) {
      count += 1;
      return count > 3;
    } else {
      return count > 4;
    }
  }

  public resizeSwiper(swipercomponent: SwiperComponent, duration = 1500, step = 300) {
    if (duration > 0) {
      if (swipercomponent) {
        if (swipercomponent.directiveRef) {
          if (swipercomponent.directiveRef.swiper()) {
            swipercomponent.directiveRef.swiper().update();
          }
        }
      }
      setTimeout(() => {
        this.resizeSwiper(swipercomponent, duration - step, step);
      }, step)
    }
  }

  public trackOrdertypesBy(index: number, ordertype: OrdertypeViewModel): number {
    return ordertype.model.id;
  }

  /**
   * Renders segmented pagination with max 10 bullets per segment
   */
  private renderSegmentedPaginationCustom(swiper: any, current: number, total: number): string {
    const SIZE = 10;
    const idx = current - 1;
    const seg = Math.floor(idx / SIZE);
    const start = seg * SIZE;
    const end = Math.min(start + SIZE, total);

    // Store swiper reference for global access (only once)
    if (!window['__swiperJump']) {
      window['__swiperJump'] = (el: HTMLElement, index: number) => {
        const container = el.closest('.swiper-container') as any;
        if (container && container.swiper) container.swiper.slideTo(index);
      };
    }

    const leftArrow = '<span class="swiper-pagination-indicator"><svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"/></svg></span>';
    const rightArrow = '<span class="swiper-pagination-indicator"><svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"/></svg></span>';
    const activeBullet = '<span class="swiper-pagination-bullet swiper-pagination-bullet-active"></span>';
    const inactiveBullet = '<span class="swiper-pagination-bullet"></span>';

    let html = '';
    if (seg > 0) html += leftArrow;
    for (let i = start; i < end; i++) html += (i === idx) ? activeBullet : inactiveBullet;
    if (seg < Math.ceil(total / SIZE) - 1) html += rightArrow;

    return html;
  }

  // Footer methods from MainNav
  public openExternalUrl(url: string): void {
    const me = this;
    me._externalLinksSettingsService.RouteToExternalLinks(url, true)
      .catch(error => {
        me._coreLogService.error("HomeComponent.openExternalUrl", "RouteToExternalLinks (catch)", error);
      });
  }

  // Footer methods - delegate to dialogs
  public openAccessibiltyDialog(): void {
    const me = this;
    me._bottomSheetHelperService.open(AccessibiltyDialogComponent, {
      data: {
        applyAccessibilitySettings: () => {
          // The service is already updated by MainNav
          me.PushChanges();
        }
      },
      panelClass: "mat-bottom-sheet-container--medium"
    }).afterDismissed().subscribe(() => {
      me.PushChanges();
    });
  }

  public openCookieDialog(): void {
    this._bottomSheetHelperService.open(CookiePolicyComponent);
  }

  public openLanguageDialog(): void {
    this._bottomSheetHelperService.open(LanguageDialogComponent);
  }

  public openLicenseDialog(): void {
    this._bottomSheetHelperService.open(LicenseDialogComponent);
  }

  public navigateToTerms(termID: number): void {
    this._router.navigate(["/termcondition", termID]);
  }
}
